(function () {
  var mq = window.matchMedia('(min-width: 990px)');
  function bind() {
    var items = document.querySelectorAll('.header__inline-menu > ul > li');
    items.forEach(function (li) {
      if (li.dataset.wbHoverBound) return;
      var details = li.querySelector('header-menu > details') || li.querySelector('details');
      if (!details) return;
      li.dataset.wbHoverBound = '1';
      li.addEventListener('mouseenter', function () { if (mq.matches) details.setAttribute('open', ''); });
      li.addEventListener('mouseleave', function () { if (mq.matches) details.removeAttribute('open'); });
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bind); } else { bind(); }
  document.addEventListener('shopify:section:load', bind);
})();
